import Vue from 'vue';


export default {
  state: {
    productionId:''
  },
  actions: {
    // 产品动态列表
    dynamicClientInfo(ctx, params){
      return Vue.http.post('/client/productManage/dynamic-client-info', params)
    },
    // 产品列表
    productionClientInfo(ctx, params){
      return Vue.http.post('/client/productManage/production-client-info', params)
    },
    // 单个动态详情接口
    dynamicDetails(ctx, params){
      return Vue.http.post('/client/productManage/dynamic-details', params)
    }
  },
  mutations: {
    setProductionId(state, payload){
      state.productionId = payload || '';
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/productManage.js